import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Comments from '@/pages/home/components/Comments';
import AppSection from '@/pages/home/components/AppSection';
import Contact from '@/pages/home/components/Contact';
import Features from '@/pages/home/components/Features';
import Carousel from '@/pages/home/components/Carousel';
import Cards from '@/pages/home/components/Cards';
import Media from '@/pages/home/components/Media';
import Topics from '@/pages/home/components/Topics';
import Ranking from '@/pages/home/components/Ranking';
import Updates from '@/pages/home/components/Updates';
import About from '@/pages/home/components/About';
import Faq from '@/pages/home/components/Faq';
import Index from '@/pages/home/components/Index';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <AppSection />
        <Contact />
        <Features />
        <Carousel />
        <Cards />
        <Media />
        <Topics />
        <Ranking />
        <Updates />
        <About />
        <Faq />
        <Index />
      </main>
      <Footer />
    </>
  );
}